import { Injectable, NgZone } from "@angular/core";
import {BaseAppDetailEnvService} from "../../base-app-detail-env.service";

@Injectable()
export class BaseSubmenuAppVpnService {
    constructor(private envCtrlSvc: BaseAppDetailEnvService,
                private ngZone: NgZone) {
    }

    getEnvCtrlService() {
        return this.envCtrlSvc;
    }

    getNgZone() {
        return this.ngZone;
    }
}
